"use client";

import { Slot } from "@radix-ui/react-slot";
import { cn } from "@scott/ui/client";
import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

const headingVariants = cva("", {
  variants: {
    variant: {
      h1: "font-bold font-heading text-2xl text-neutral-darker uppercase tracking-wide md:text-3xl md:tracking-wider",
      h2: "font-bold font-heading text-neutral-darker text-xl uppercase tracking-wide md:text-2xl md:tracking-wider",
      h3: "font-bold font-heading text-lg text-neutral-darker uppercase md:text-xl",
      h4: "font-bold font-heading text-base text-neutral-darker uppercase tracking-wider",
      h5: "font-bold font-heading text-neutral-darker text-sm uppercase tracking-widest",
      h6: "font-bold font-heading text-neutral-darker text-xs uppercase tracking-widest",
    },
  },
  defaultVariants: {
    variant: "h1",
  },
});

export interface HeadingProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
    VariantProps<typeof headingVariants> {
  asChild?: boolean;
  hasUnderline?: boolean;
  wrapperClass?: string;
}

const Heading = ({
  className,
  children,
  variant,
  wrapperClass,
  hasUnderline,
  asChild = false,
  ref,
  ...props
}: HeadingProps & { ref?: React.RefObject<HTMLHeadingElement | null> }) => {
  const Comp = asChild ? Slot : String(variant);
  return (
    <Comp
      className={cn(
        "flex flex-1 flex-col gap-0",
        headingVariants({ variant, className }),
        wrapperClass ? wrapperClass : "items-start"
      )}
      ref={ref}
      {...props}
    >
      {children}
      {hasUnderline && <div>–</div>}
    </Comp>
  );
};
Heading.displayName = "Heading";

export { Heading, headingVariants };
